import type { SVGProps } from 'react';
const DawnFlagMW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MW_svg__a)">
      <path fill="#262626" d="M0 5.333h22V0H0z" />
      <path
        fill="#E42038"
        d="M11 9.6c2.025 0 3.666-1.671 3.666-3.733S13.025 2.133 11 2.133 7.333 3.805 7.333 5.867C7.333 7.928 8.975 9.6 11 9.6"
      />
      <path fill="#E42038" d="M0 10.667h22V5.333H0z" />
      <path fill="#47B849" d="M0 16h22v-5.333H0z" />
    </g>
  </svg>
);
export default DawnFlagMW;
